import React, { useContext } from 'react'
import { Badge, Col, Row } from 'antd'
import ResourceRow from './ResourceRow'
import { DataContext, StyleContext } from './GanttChart'
const BottomBar = ({ handleScrollThird, thirdDivRef }) => {
  const { resources } = useContext(DataContext)
  const { columnValue, lockHeight } = useContext(StyleContext)

  return (
    <div>
      <Row style={{ height: '100%' }}>
        <Col span={4} style={{ outline: ' 0.5px solid rgb(233 234 235)' }}>
          <h3 className='ml-10' style={{ marginBottom: '2.5px' }}>
            Cranes
          </h3>

          <Row>
            <Col span={9}>
              <h3 className='bottom-title'>Convent</h3>
            </Col>
            <Col span={15}>
              <div>
                {resources.map((r) => (
                  <div key={r.id} className='heading-row'>
                    <h4 className='h1-resource'>
                      {r.crane_name}{' '}
                      <Badge
                        className='resource-badges'
                        color={r.color}
                      ></Badge>
                    </h4>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </Col>
        <Col
          span={20}
          style={{
            outline: ' 0.5px solid rgb(233 234 235)',
            width: '100%',
            overflow: 'scroll'
          }}
          onScroll={handleScrollThird}
          ref={thirdDivRef}
        >
          <Row style={{ visibility: 'hidden' }}>
            <h3>Cranes</h3>
          </Row>
          {resources.map((r) => (
            <ResourceRow key={r.id} color={r.color} r={r} />
          ))}
        </Col>
      </Row>
      <style>{`
.resource-badges .ant-badge-status-dot{
height:8px !important;
width:8px !important;
margin-left: 8px;
}
      .ml-10
      {
        margin-left: 10px;
      }
         .bottom-title{
          height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
         }

          .heading-row {
            display: flex;
            align-items: center;
            border: 0.5px solid rgb(233 233 233);
            border-left: none;
            height:  ${lockHeight ? 29 : columnValue / 5 + 10}px;
            padding:0 15px;
            margin-top: -1px;
          }

          .h1-resource {
            width: 100%;
            border: none;
            outline: none;
            text-align: end;
            background: none;
            font-weight:400
          }
        `}</style>
    </div>
  )
}

export default BottomBar
